import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import { withFirebase } from '../Firebase';
import logo from "../assets/logo.png"

import "./ForgottenPassword.css";

class ForgottenPassword extends Component {

    render() {
        let width = window.innerWidth;
        if (width > 768) {
            return (
                <div className="container">
                    <ForgottenPasswordForm />
                </div>
            );
        } else {
            return (
                <div>
                    <ForgottenPasswordFormMobile />
                </div>
            );
        }
    }

}

const INITIAL_STATE = {
    email: '',
    error: null,
};

class ForgottenPasswordFormBase extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };
    }

    onSubmit = event => {
        const { email } = this.state;

        this.props.firebase
            .doPasswordReset(email)
            .then(() => {
                this.setState({ ...INITIAL_STATE });
                this.props.history.push(ROUTES.SIGN_IN);
            })
            .catch(error => {
                this.setState({ error });
            });

        event.preventDefault();
    };

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {
        const { email, error } = this.state;

        return (

            <div className="container">

                <div className="row logo-container">
                    <div className="col"></div>
                    <div className="col">


                        <img className="logo" src={logo} alt="Logo" />


                        <div className="catch-line">
                            Les idées s'élèvent
                        </div>

                    </div>
                    <div className="col"></div>
                </div>

                <div className="row">
                    <div className="col "></div>
                    <div className="col login-container">
                        <form onSubmit={this.onSubmit}>

                            <div className="forgot-form-container">


                                <div className="form-group">
                                    <label htmlFor="email" className="basic-text">Votre email</label>
                                    <input onChange={this.onChange} value={email} type="email" className="forgotten-search-field container placeholder-label" name="email" aria-describedby="emailHelp" placeholder="email" />
                                </div>



                                <div className="text-center">
                                    <button type="submit" className="signin-button">Envoyer un lien</button>
                                </div>

                                {error && <p>{error.message}</p>}
                            </div>

                        </form>
                    </div>
                    <div className="col"></div>



                </div>
            </div>
        );
    }
}

class ForgottenPasswordFormBaseMobile extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };
    }

    onSubmit = event => {
        const { email, password } = this.state;

        this.props.firebase
            .doSignInWithEmailAndPassword(email, password)
            .then(() => {
                this.setState({ ...INITIAL_STATE });
                this.props.history.push(ROUTES.HOME);
            })
            .catch(error => {
                this.setState({ error });
            });

        event.preventDefault();
    };

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {
        const { email, error } = this.state;

        return (

            <div className="container">

                <div className="row logo-container">


                    <img className="logo-mobile" src={logo} alt="Logo" />


                    <div className="catch-line">
                        Les idées s'élèvent
                    </div>

                </div>

                <div className="row">
                    <div className="login-container">
                        <form onSubmit={this.onSubmit}>

                            <div className="forgot-form-container-mobile">

                                <div>
                                    <div className="form-group">
                                        <label htmlFor="email" className="basic-text">Votre email</label>
                                        <input onChange={this.onChange} value={email} type="email" className="forgotten-search-field container placeholder-label" name="email" aria-describedby="emailHelp" placeholder="email" />
                                    </div>
                                </div>

                                <div className="text-center">
                                    <button type="submit" className="signin-button">Envoyer un lien</button>
                                </div>

                                {error && <p>{error.message}</p>}
                            </div>

                        </form>
                    </div>

                </div>
            </div>
        );
    }
}


const ForgottenPasswordForm = withRouter(withFirebase(ForgottenPasswordFormBase));
const ForgottenPasswordFormMobile = withRouter(withFirebase(ForgottenPasswordFormBaseMobile));


export default ForgottenPassword;
export { ForgottenPasswordForm };
